export const INTEGRATION_TYPES = {
  INTERCOM: 'Intercom Integration',
  RUDDERSTACK: 'Rudderstack Integration',
  ZOHO_DESK: 'Zoho Desk Integration',
  STRIPE_CUSTOMER_PORTAL: 'Stripe - Customer Portal',
  DYNAMIC_LINKS: 'Dynamic Links Integration'
};
